import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export default {
  namespaced: true,
  state () {
    return {
      publicSectorInformation: {
        publicOrganismCode: '',
        contractReference: ''
      },
      buyerCentres: {
        receiverAdministrativeCentre: {
          code: '',
          name: ''
        }
      }
    }
  },
  actions,
  getters,
  mutations
}
